import { DEFAULT_STATE } from '../constants'

export const initialSizeState = {
  sizeUnit: DEFAULT_STATE.sizeUnit,
  wholePrintSize: DEFAULT_STATE.wholePrintSize,
  largestPrintSize: DEFAULT_STATE.largestPrintSize,
  sizePreset: DEFAULT_STATE.sizePreset,
}
